module.exports = __webpack_public_path__ + "static/media/7.8818730b.jpeg";